<style lang="stylus" scoped>
    #recommend-feature
        margin-top 24px
        .title
            font-size 16px
            font-weight 700
            line-height 20px
            color #000
        .bar-main
            display flex
            column-gap 24px
            justify-content space-between
            margin-top 24px
            min-width 970px
            .recommend-ai
                flex 1
                border-radius 8px
                background #E8F5FF
                padding 16px
                min-width 505px
                .top-bar
                    display flex
                    align-items center
                    justify-content space-between
                    .title
                        position relative
                        display flex
                        align-items center
                        img
                            margin-right 8px
                            display block
                            width 24px
                            height 24px
                        img.white-star
                            position absolute
                            right -30px
                            bottom 8px
                            width 18.82px
                            height 18.82px
                    .to-more-ai-list
                        margin-left 10px
                        color #017FFF
                        cursor pointer
                        &:hover
                            opacity 0.8
                .ai-lists
                    margin-top 16px
                    display grid
                    grid-template-columns repeat(auto-fill, minmax(148px, 1fr))
                    grid-gap 8px
                    max-height 104px
                    overflow hidden
                    .ai-item
                        // width 32.459%
                        max-width 220px
                        min-width 148px
                        height 48px
                        border-radius 6px
                        background #fff
                        padding 8px
                        display flex
                        align-items center
                        border 1px solid transparent
                        cursor pointer
                        img
                            display block
                            width 32px
                            height 32px
                            margin-right 8px
                        span
                            font-size 14px
                            line-height 18px
                            font-weight 400
                            color #000
                        &:hover
                            border-color  #017FFF

            .other-recommend
                width 214px
                height 176px
                border-radius 8px
                cursor pointer
                overflow hidden
                img
                    display flex
                    width 100%
                    height 100%
                    object-fit cover
                .hover-img
                    display none
                &:hover
                    .normal-img
                        display none
                    .hover-img
                        display block
            .subject-wrapper
                position relative
                width 100%
                height 100%
                overflow hidden
                >img
                    position absolute
                    width 100%
                    height 100%

                .subject-title
                    width min-content
                    height 20px
                    margin auto
                    margin-top 16px
                    position relative
                    text-align center
                    padding 0 3px
                    .left-star
                        position absolute
                        left -8px
                        bottom 5px
                        width 8px
                        height 8px
                        display block
                    .right-star
                        position absolute
                        right -8px
                        top 0
                        width 8px
                        height 8px
                        display block
                    .title-content
                        span
                            font-size 14px
                            font-weight 700
                            line-height 18px
                            background linear-gradient(to right, #00A3FF, #346DFF, #A64DFF)
                            -webkit-background-clip text
                            color transparent
                            white-space nowrap
                        .bottom-line
                            width 100%
                            height 6px
                            background linear-gradient(to right, rgba(55, 231, 255, 0.1), rgba(98, 1, 255, 0.4))
                            transform skewX(-20deg)
                            margin auto
                            position absolute
                            bottom 2px

    @media (min-width: 1920px)
         #recommend-feature
            .bar-main
                .recommend-ai
                    .ai-lists
                        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr))
                        .ai-item
                            max-width 270px
</style>

<template>
    <div id="recommend-feature">
        <div class="title">
            {{ $t("featureTitle") }}
        </div>
        <div class="bar-main">
            <div class="recommend-ai">
                <div class="top-bar">
                    <div class="title">
                        <img :src="require('@/home/assets/img/newPage/recommend-new/ai-icon.svg')" alt="" />
                        <span>{{ $t("aiTitle") }}</span>
                        <img class="white-star" :src="require('@/home/assets/img/newPage/recommend-new/white-star.svg')" alt="" />
                    </div>
                    <div class="to-more-ai-list" @click="toMoreAI">{{ $t("moreAI") }}</div>
                </div>
                <div class="ai-lists" ref="aiLists">
                    <template v-for="(item, index) in aiFuncs">
                        <div class="ai-item" :key="index" @click="handleClickAI(item)" v-if="index < AIShowNum">
                            <img :src="require(`@/home/assets/img/aiList/${item.name}.svg`)" alt="" class="icon" />
                            <span>{{ item.label }}</span>
                        </div>
                    </template>
                </div>
            </div>
            <div class="recommend-subject other-recommend" @click="toSubject">
                <template v-if="internal">
                    <template v-if="lang == 'zh'">
                        <img class="normal-img" :src="require('@/home/assets/img/newPage/recommend-new/subject.png')" alt="" />
                        <img class="hover-img" :src="require('@/home/assets/img/newPage/recommend-new/subject-hover.png')" alt="" />
                    </template>
                    <template v-else>
                        <img class="normal-img" :src="require('@/home/assets/img/newPage/recommend-new/en-subject.png')" alt="" />
                        <img class="hover-img" :src="require('@/home/assets/img/newPage/recommend-new/en-subject-hover.png')" alt="" />
                    </template>
                </template>

                <div class="subject-wrapper" v-else>
                    <img class="normal-img" :src="require('@/home/assets/img/newPage/recommend-new/subject-bg.png')" alt="" />
                    <img class="hover-img" :src="require('@/home/assets/img/newPage/recommend-new/subject-bg-hover.png')" alt="" />
                    <div class="subject-title">
                        <img class="left-star" :src="require('@/home/assets/img/newPage/recommend-new/left-star.png')" alt="" />
                        <img class="right-star" :src="require('@/home/assets/img/newPage/recommend-new/right-star.png')" alt="" />
                        <div class="title-content">
                            <span>{{ $t("subjectTitle") }}</span>
                            <div class="bottom-line"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="recommend-academy other-recommend" @click="toAcademy">
                <template v-if="internal">
                    <template v-if="lang == 'zh'">
                        <img class="normal-img" :src="require('@/home/assets/img/newPage/recommend-new/academy.png')" alt="" />
                        <img class="hover-img" :src="require('@/home/assets/img/newPage/recommend-new/academy-hover.png')" alt="" />
                    </template>
                    <template v-else>
                        <img class="normal-img" :src="require('@/home/assets/img/newPage/recommend-new/en-academy.png')" alt="" />
                        <img class="hover-img" :src="require('@/home/assets/img/newPage/recommend-new/en-academy-hover.png')" alt="" />
                    </template>
                </template>

                <div class="subject-wrapper" v-else>
                    <img class="normal-img" :src="require('@/home/assets/img/newPage/recommend-new/academy-bg.png')" alt="" />
                    <img class="hover-img" :src="require('@/home/assets/img/newPage/recommend-new/academy-bg-hover.png')" alt="" />
                    <div class="subject-title">
                        <img class="left-star" :src="require('@/home/assets/img/newPage/recommend-new/left-star.png')" alt="" />
                        <img class="right-star" :src="require('@/home/assets/img/newPage/recommend-new/right-star.png')" alt="" />
                        <div class="title-content">
                            <span v-if="!internal && lang === 'zh'">{{ $t("templatesCommunity") }}</span>
                            <span v-else>{{ $t("academyTitle") }}</span>
                            <div class="bottom-line"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Mixins } from "vue-property-decorator";
    import addNew from "../addNew";

    @Component({
        components: {},
    })
    export default class recommendFeature extends Mixins(addNew) {
        get aiFuncs() {
            return [
                { name: "aiflowchart", key: "flowchart", libKey: "empty", label: this.$t("aiflowchart") },
                { name: "aimindmap", key: "mindmap", libKey: "mindmap", label: this.$t("aimindmap") },
                { name: "aiTimeline", key: "timeline", label: this.$t("aiTimeline") },
                { name: "aiDraw", key: "aiDraw", label: this.$t("aiDraw") },
                { name: "aiQA", key: "chat", label: this.$t("aiQA") },
                { name: "aiTable", key: "table", label: this.$t("aiTable") },
                { name: "aiList", key: "list", label: this.$t("aiList") },
                { name: "aiSwot", key: "swot", label: this.$t("aiSwot") },
                { name: "aiCanvas", key: "canvas", label: this.$t("aiCanvas") },
                { name: "aiPest", key: "pest", label: this.$t("aiPest") },
                { name: "aiStory", key: "story", label: this.$t("aiStory") },
                { name: "aiPortrait", key: "portrait", label: this.$t("aiPortrait") },
                { name: "aiDocument", key: "documentAnalysis", label: this.$t("aiDocument") },
                { name: "aiChart", key: "line", label: this.$t("aiChart") },
                { name: "aiGauge", key: "gauge", label: this.$t("aiGauge") },
            ];
        }

        handleClickAI(item) {
            this.activeAIKey = item.key;
            this.aiPanelKey = item.libKey ?? "";
            this.addNewPage("aiTool");
            let AI_type = item.key;
            if (item.key === "line") {
                AI_type = "chart";
            }
            if (item.key === "gauge") {
                AI_type = "dial";
            }
            this.sensors.track("clickupperAIbanner", {
                Catalogues: "AIrecommendation",
                AI_type,
            });
        }

        toMoreAI() {
            this.$router.push("/new/ai-list");
            this.sensors.track("clickMoreAITools", {
                Catalogues: "AIrecommendation",
            });
        }

        toSubject() {
            let url = "https://www.edrawmax.cn/templates/album/all";
            if (!this.internal) {
                this.$router.push(`/${this.lang}/store`);
                if (!this.$validateLogin()) return;
                this.$store.commit("setState", {
                    type: "templateSelect",
                    data: "tags",
                });
                return;
            }
            this.aClick(url);
            this.sensors.track("clickCommunityAds", {
                Catalogues: "communityADS",
                button_location: "left",
                click_type: "collections",
            });
        }

        toAcademy() {
            let url = "https://course.edrawsoft.cn/edrawmax";
            if (!this.internal) {
                url = "https://www.edrawmax.com/templates/";
            }
            window.open(url, "_blank");
            this.sensors.track("clickCommunityAds", {
                Catalogues: "communityADS",
                button_location: "right",
                click_type: "college",
            });
        }

        AIShowNum = 0;
        recommendAIResize() {
            let BOXWIDTH = 148;
            const MARGIN = 4;

            if (document?.body?.clientWidth >= 1920) {
                BOXWIDTH = 220;
            }

            let container = this.$refs.aiLists as HTMLElement;
            let containerW = container.clientWidth;
            this.AIShowNum = Math.floor(containerW / (BOXWIDTH + MARGIN)) * 2;
        }

        resizeEvent() {
            this.recommendAIResize();
        }

        aClick(href) {
            let a = document.createElement("a");
            a.href = href;
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        created() {}
        mounted() {
            this.resizeEvent();
            window.addEventListener("resize", this.resizeEvent);
        }
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeEvent);
        }
    }
</script>
<i18n>
{
    "zh": {
        "featureTitle": "推荐",
        "aiTitle": "使用亿图AI，一句话生成绘图",
        "moreAI": "更多AI功能",

        "aiflowchart": "AI 流程图",
        "aimindmap": "AI 思维导图",
        "aiTimeline": "AI 时间线",
        "aiDraw": "AI 绘画",
        "aiQA": "AI 问答",
        "aiTable": "AI 表格",
        "aiList": "AI 列表",
        "aiSwot": "AI SWOT分析",
        "aiCanvas": "AI 精益画布",
        "aiPest": "AI PEST分析",
        "aiStory": "AI 用户故事",
        "aiPortrait": "AI 用户画像",
        "aiDocument": "AI 文件分析",
        "aiChart": "AI 图表",
        "aiGauge": "AI 仪表盘",

        "newFile": "未命名文件",
        "create": "正在创建文件中，请稍后再试",

        "subjectTitle": "精选模板专题",
        "academyTitle": "亿图学堂",
        "templatesCommunity": "模板社区"
    },
    "en": {
        "featureTitle": "Recommend",
        "aiTitle": "Generate your diagram in several words by edraw AI",
        "moreAI": "More AI Tools",

        "aiflowchart": "AI Flowchart",
        "aimindmap": "AI Mindmap",
        "aiQA": "AI Chat",
        "aiTimeline": "AI Timeline",
        "aiPicture": "AI picture analysis",
        "aiDraw": "AI Drawing",

        "aiTable": "AI Table",
        "aiList": "AI List",
        "aiSwot": "AI SWOT Analysis",
        "aiCanvas": "AI Lean Canvas",
        "aiPest": "AI PEST Analysis",
        "aiStory": "AI User Story",
        "aiPortrait": "AI User Profile",
        "aiDocument": "AI Document Analysis",
        "aiChart": "AI Chart",
        "aiGauge": "AI Dial",


        "newFile": "Unnamed File",
        "create": "Creating file, please try again later.",
        "subjectTitle": "Trending Collections",
        "academyTitle": "Templates Community"
    },
    "fr": {
        "featureTitle": "Conseillé",
        "aiTitle": "Générez votre diagramme en quelques mots grâce à Edraw AI.",
        "moreAI": "Plus d'outils d'IA",

        "aiflowchart": "Organigramme IA",
        "aimindmap": "Carte mentale par IA",
        "aiQA": "Chat AI",
        "aiTimeline": "Chronologie IA",
        "aiPicture": "Analyse d'image par IA",
        "aiDraw": "Dessin AI",

        "aiTable": "Tableau IA",
        "aiList": "Liste IA",
        "aiSwot": "Analyse SWOT IA",
        "aiCanvas": "Lean Canvas IA",
        "aiPest": "Analyse PEST IA",
        "aiStory": "Récit utilisateur IA",
        "aiPortrait": "Profil utilisateur IA",
        "aiDocument": "Analyse de documents IA",
        "aiChart": "Graphique IA",
        "aiGauge": "Cadran IA",

        "newFile": "Fichier sans nom",
        "create": "Création du fichier, veuillez réessayer plus tard",
        "subjectTitle": "Collections tendance",
        "academyTitle": "Communauté des Modèles"
    },
    "de": {
        "featureTitle": "Empfohlen",
        "aiTitle": "Erstellen Sie Ihr Diagramm in wenigen Worten mit Edraw AI",
        "moreAI": "wenigen Worten mit Edraw AI",

        "aiflowchart": "AI Flussdiagramm",
        "aimindmap": "AI Mindmap",
        "aiQA": "AI Chat",
        "aiTimeline": "AI Zeitachse",
        "aiPicture": "AI Bildanalyse",
        "aiDraw": "AI Drawing",

        "aiTable": "AI Tabelle",
        "aiList": "AI Liste",
        "aiSwot": "AI SWOT-Analyse",
        "aiCanvas": "AI Lean Canvas",
        "aiPest": "AI STEP-Analyse",
        "aiStory": "AI User Story",
        "aiPortrait": "AI Benutzerprofil",
        "aiDocument": "AI Dokumentanalyse",
        "aiChart": "KI-Diagramm",
        "aiGauge": "AI Ziffernblatt",

        "newFile": "Unbenannte Datei",
        "create": " Datei wird erstellt, versuchen Sie es später erneut",
        "subjectTitle": "Beliebte Sammlungen",
        "academyTitle": "Schablonen Gemeinschaft"
    },
    "jp": {
        "featureTitle": "おすすめ",
        "aiTitle": "Edraw AIを使って、数単語から図を生成できます",
        "moreAI": "を生成できます",

        "aiflowchart": "AIフローチャート",
        "aimindmap": "AIマインドマップ",
        "aiQA": "AIチャット",
        "aiTimeline": "AIタイムライン",
        "aiPicture": "AI画像解析",
        "aiDraw": "AI描画",

        "aiTable": "AIテーブル",
        "aiList": "AIリスト",
        "aiSwot": "AI SWOT分析",
        "aiCanvas": "AIリーンキャンバス",
        "aiPest": "AI PEST分析",
        "aiStory": "AIユーザーストーリー",
        "aiPortrait": "AIユーザープロファイル",
        "aiDocument": "AIドキュメント分析",
        "aiChart": "AI チャート",
        "aiGauge": "AIダイヤル",

        "newFile": "名前のないファイル",
        "create": "ファイルを作成しています。しばらくしてからもう一度お試しください",
        "subjectTitle": "話題のコレクション",
        "academyTitle": "テンプレートコミュニティ"
    },
    "es": {
        "featureTitle": "Recomendado",
        "aiTitle": "Genera tu diagrama en varias palabras con Edraw AI",
        "moreAI": "Más herramientas de AI",

        "aiflowchart": "Diagrama de flujo con IA",
        "aimindmap": "Mapa mental con IA",
        "aiQA": "Chat de AI",
        "aiTimeline": "Línea de tiempo con IA",
        "aiPicture": "Análisis de imágenes con IA",
        "aiDraw": "Dibujo de AI",

        "aiTable": "Tabla con IA",
        "aiList": "Lista con IA",
        "aiSwot": "Análisis SWOT con IA",
        "aiCanvas": "Lienzo en blanco con IA",
        "aiPest": "Análisis PEST con IA",
        "aiStory": "Caso de usuario con IA",
        "aiPortrait": "Perfil de usuario con IA",
        "aiDocument": "Análisis de documentos con AI",
        "aiChart": "Gráfico IA",
        "aiGauge": "Dial con IA",

        "newFile": "Archivo sin nombre",
        "create": "Creando archivo, por favor intente nuevamente más tarde.",
        "subjectTitle": "Tendencias de colecciones",
        "academyTitle": "Comunidad de Plantillas"
    },
    "pt": {
        "featureTitle": "Recomendado",
        "aiTitle": "Gere seu diagrama em várias palavras com Edraw AI",
        "moreAI": "Mais ferramentas de IA",

        "aiflowchart": "Fluxograma de IA",
        "aimindmap": "Mapa de ideias de IA",
        "aiQA": "Chat por IA",
        "aiTimeline": "Linha do tempo de IA",
        "aiPicture": "Análise de imagem por IA",
        "aiDraw": "Desenho por IA",

        "aiTable": "Tabela de IA",
        "aiList": "Lista de IA",
        "aiSwot": "Análise de SWOT de IA",
        "aiCanvas": "Lean Canvas de IA",
        "aiPest": "Análise PEST de IA",
        "aiStory": "História de usuário de IA",
        "aiPortrait": "Perfil de usuário de IA",
        "aiDocument": "Análise de documento de IA",
        "aiChart": "Gráfico de IA",
        "aiGauge": "Mostrador de IA",

        "newFile": "Ficheiro Sem Nome",
        "create": "Criando ficheiro, por favor, tentar mais tarde.",
        "subjectTitle": "Coleções mais populares",
        "academyTitle": "Comunidade de Modelos"
    },
    "it": {
        "featureTitle": "Consigliato",
        "aiTitle": "Genera il tuo diagramma in diverse parole con Edraw AI",
        "moreAI": "Altri strumenti AI",

        "aiflowchart": "Diagramma di flusso AI",
        "aimindmap": "Mappa mentale AI",
        "aiQA": "Chat AI",
        "aiTimeline": "Timeline AI",
        "aiPicture": "Analisi immagine AI",
        "aiDraw": "Disegno AI",

        "aiTable": "Tabella AI",
        "aiList": "Elenco AI",
        "aiSwot": "Analisi SWOT AI",
        "aiCanvas": "Lean Canvas AI",
        "aiPest": "Analisi PEST AI",
        "aiStory": "Storia utente AI",
        "aiPortrait": "Profilo utente AI",
        "aiDocument": "Analisi documenti AI",
        "aiChart": "Grafico IA",
        "aiGauge": "Quadrante AI",

        "newFile": "File Senza Nome",
        "create": "Creazione file in corso. Si prega di riprovare.",
        "subjectTitle": "Raccolta di tendenza",
        "academyTitle": "Comunità di Modelli"
    }
}
</i18n>
